document.addEventListener('crPickupActivated', function (e) {
  setTimeout(() => {
    console.log('------------------------------------- Apply discount ----------------------------')
    fetch(`/discount/OPHAALKORTING`);      
  }, 1000);  
})

document.addEventListener('crJQActivated', function (e) {
  jqCR('.cr-shipping-method').on('click', function(){
    console.log('cancel discount')
    fetch(`${window.Shopify.routes.root}cart/update.js`, {
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      body: JSON.stringify({ discount: '' }) // empty string removes all codes
    }).then(r => r.json());  
  })

  fetch(`${window.Shopify.routes.root}cart/update.js`, {
    method: 'POST',
    headers: {'Content-Type': 'application/json'},
    body: JSON.stringify({ discount: '' }) // empty string removes all codes
  }).then(r => r.json()).then((r) => {
    const discountLabel = jqCR('.discounts__discount').length
    const shippingMethodSelected = jqCR('.cr-shipping-method').hasClass('selected')
    if (shippingMethodSelected === true && discountLabel > 0) {
      console.log('refresh')
      location.reload()
    }
    console.log('done', r, discountLabel)
  });
})